module.exports = __webpack_public_path__ + "media/outside-480.a549fd24.mp4";